import React, { useState, useEffect } from "react";
import NumbersSelect from "../ui/NumbersSelect";
import Sidepanel from "../navigation/Sidepanel";
import Marquee from "../ui/Marquee";
import { PlusCircle, RefreshCw } from "lucide-react";
const Hero = () => {
  // State management
  const [isMobile, setIsMobile] = useState(false);
  const [bottleCount, setBottleCount] = useState(1);
  const [activeSidebar, setActiveSidebar] = useState(null);

  // Effects
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Styles
  const desktopHeroStyles = {
    backgroundImage: `url("/assets/img/landing/drops-blue-bg-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.png")`,
    backgroundSize: "cover",
    backgroundPosition: "bottom",
    backgroundRepeat: "no-repeat",
  };

  const mobileHeroStyles = {
    backgroundColor: "#1e40af",
    backgroundImage: `url("/assets/img/landing/drops-blue-bg-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.png")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  };

  return (
    <div
      className="flex flex-col relative overflow-hidden items-center justify-center bg-blue-800"
      style={desktopHeroStyles}
      id="hero"
    >
      {isMobile ? (
        // Mobile Layout
        <div className="pt-32 md:pt-40 px-36 pb-16 flex items-center">
          <div className="w-full relative z-40">
            <div className="flex flex-col items-center gap-4">
              <div className="w-full h-[280px] overflow-hidden flex justify-center items-center">
                <img
                  className="h-full w-auto object-contain"
                  src="/assets/img/landing/full-boder-sug-drops-blue-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.png"
                  alt="Botellón de agua purificada"
                />
              </div>
              <h1 className="text-6xl font-bold text-white tracking-wider leading-[80px] fraunces flex flex-col text-center">
                Agua
                <span className="-mt-4">Purificada</span>
              </h1>

              <h3 className="text-2xl  text-white leading-6 text-center ">
                Pide Botellones <span className="fraunces font-bold">20lt</span>{" "}
                y recambios a domicilio en{" "}
                <span className="fraunces font-bold">Barranquilla</span>
              </h3>
              <div className="flex flex-col items-center gap-4 pt-4">
                <a href="/nuevo-pedido">
                  <button className="hover:scale-105 transition-transform duration-300 h-10 px-4 bg-stone-50 text-stone-800 rounded-xl font-medium text-lg flex items-center gap-2">
                    <PlusCircle size={16} />
                    Pedir Botellón
                  </button>
                </a>
                <a href="/recambios">
                  <button className="hover:scale-105 transition-transform duration-300 h-10 px-4 bg-stone-50 text-stone-800 rounded-xl font-medium text-lg flex items-center gap-2">
                    <RefreshCw size={16} />
                    Pedir Recambios
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        // Desktop Layout
        <div className="w-screen flex items-center justify-center pt-24 max-w-6xl">
          <div className="flex flex-col gap-8 w-full z-20 px-8 2xl:px-0">
            <h1 className="text-8xl font-bold text-white tracking-wider leading-[96px] fraunces flex flex-col">
              Agua
              <span className="-mt-4">Purificada</span>
            </h1>
            <h3 className="text-2xl  max-w-[75%] text-white leading-6">
              Pide Botellones <span className="fraunces font-bold">20lt</span> y
              recambios a domicilio en{" "}
              <span className="fraunces font-bold">Barranquilla</span>
            </h3>
            <div className="flex items-center gap-4">
              <a href="/nuevo-pedido">
                <button className="hover:scale-105 transition-transform duration-300 h-10 px-4 bg-stone-50 text-stone-800 rounded-xl font-medium text-lg flex items-center gap-1">
                  <PlusCircle size={16} />
                  Pedir Botellón
                </button>
              </a>
              <a href="/recambios">
                <button className="hover:scale-105 transition-transform duration-300 h-10 px-4 bg-stone-50 text-stone-800  rounded-xl font-medium text-lg flex items-center gap-1">
                  <RefreshCw size={16} />
                  Pedir Recambios
                </button>
              </a>
            </div>
          </div>
          <div className="w-full h-[580px] pr-24 overflow-visible">
            <img
              src="/assets/img/landing/fragment-jug-blue-bg-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.png"
              className="w-full h-full object-cover overflow-visible"
              alt="Botellón de agua purificada"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Hero;
